import React, { useState, useEffect } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { options } from '../config'
import html2canvas from 'html2canvas';

import '../assets/css/custom.css';
import '../assets/css/main.css';

import ScreenshotContainer from './Screenshot/ScreenshotContainer';
import ReportModal from './ReportModal';
import { serverIP } from '../config';

import iinfo from '../assets/images/i-info.svg'
import TFAILogo from '../assets/images/TFAI-logo-cr.svg';

const Navbar = ({ deviceSize }) => {
    const [isOpen, setIsOpen] = useState(false)
    const menuToggle = () => {
        setIsOpen(!isOpen)
    }
    const closeNavBox = () => {
        setIsOpen(false)
    }

    // 問題回報截圖功能
    const [toggleScreenshotPicker, setToggleScreenshotPicker] = useState(false);
    const [screenshotArea, setScreenshotArea] = useState(null);
    useEffect(() => {
        if (screenshotArea) {
            let msg = screenshotArea
            captureScreenShot(msg.x, msg.y, msg.width, msg.height)
            setScreenshotArea(null)
        }
    }, [screenshotArea]);

    const preTakeScreenShot = () => {
        setIsOpen(false)
        setToggleScreenshotPicker(true)
    }

    const closeScreenshotPicker = () => {
        setToggleScreenshotPicker(false);
    }

    const getSreenshotArea = (msg) => {
        setToggleScreenshotPicker(false)
        setScreenshotArea(msg)
    }

    // 問題回報彈跳視窗
    const [toggleReportModal, setToggleReportModal] = useState(false)
    const [captureImage, setCaptureImage] = useState(null)
    const captureScreenShot = (posX, posY, width, height) => {
        html2canvas(document.body, {
            y: window.scrollY,
            scrollY: 0,
            useCORS: true,
            allowTaint: false
        }).then((canvas) => {
            let tempCanvas = document.createElement('canvas')
            let tempCanvasContext = tempCanvas.getContext('2d')
            tempCanvas.width = width
            tempCanvas.height = height
            tempCanvasContext.drawImage(canvas, posX, posY, width, height, 0, 0, width, height)
            let screenshotImg = tempCanvas.toDataURL("image/jpeg")
            setCaptureImage(screenshotImg)
            setToggleReportModal(true)
        })
    }

    return (
        <>
            {toggleReportModal && <ReportModal toggleReportModal={toggleReportModal} setToggleReportModal={setToggleReportModal}
                captureImage={captureImage} setCaptureImage={setCaptureImage} />}
            {toggleScreenshotPicker ? (
                <ScreenshotContainer
                    closeScreenshotPicker={closeScreenshotPicker}
                    getSreenshotArea={getSreenshotArea}
                    fullScreenMode={deviceSize === 'A' ? true : false}
                />
            ) : null}
            <Nav className={'navbar'}>
                <NavLink className="navbar-brand ms-3 d-lg-none flex-grow-1" to="/" onClick={closeNavBox}>
                    <img src={TFAILogo} alt="TFAI-logo" width="45" />
                </NavLink>
                <div className="i-links">
                    <NavLink to="/guide" onClick={closeNavBox}>
                        <img alt="iinfo" src={iinfo} width="25" data-bs-toggle="tooltip" data-bs-placement="bottom" title="網站說明" />
                    </NavLink>
                </div>
                <div className={isOpen ? "menu-toggle open" : "menu-toggle"} onClick={menuToggle}>
                    <div className="hamburger"></div>
                </div>
            </Nav>
            <Nav className={isOpen ? "navBox navBox--open" : "navBox"}>
                <div className="closeBlock" onClick={closeNavBox}></div>
                <div className="navBox-site" >
                    <ul className="site-nav">
                        <li>
                            <NavLink to="/" className="site-navlink d-none d-lg-block align-baseline" onClick={menuToggle}>
                                <aside><img alt="logo" src={TFAILogo} width="40" /></aside>藏品檢索系統首頁
                            </NavLink>
                        </li>
                        <li><NavLink to='/guide' className="site-navlink" onClick={menuToggle}> 網站使用說明 </NavLink></li>
                        <li><a className="site-navlink a-disabled"> 中心藏品 </a>
                            <ul className="site-navSub">
                                {options.map(option => (
                                    <li key={option.value}>
                                        <NavLink
                                            to={`/collection?keyWord=&advanceSearch=[]&selectedOptions=[{"value":"${option.value}","label":"${option.label}"}]&startDate=&endDate=&page=1`}
                                            className="site-navSubLink"
                                            onClick={menuToggle}
                                        >
                                            <Search size={15} style={{ marginRight: 12 }} />
                                            {option.label}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </li>
                        <li><a className="site-navlink" href="https://www.tfai.org.tw/downloads/rent"> 電影資料租借 </a></li>
                        <li>
                            <a className="site-navlink" href={serverIP + '/media/download/1955_1981_TaiwaneseCinema.pdf'} target={"_blank"} rel="noreferrer">
                                1955-1981年間台語片作品資料查證與首輪上映紀錄
                            </a>
                        </li>
                        <li><a className="site-navlink" style={{ cursor: 'pointer' }} onClick={preTakeScreenShot}>問題回報</a></li>
                    </ul>
                </div>
            </Nav>

            <Outlet />
        </>
    );
};

export default Navbar;